export const BASE_URL=(process.env.NODE_ENV === 'production' ? 'https://www.jeban.com/api/v1' : 'http://www.jeban.test/api/v1')
export const PUBLIC_PATH=(process.env.NODE_ENV === 'production' ? '/make-a-wish/' : '/')

// export const BASE_URL='http://172.20.10.2:8000/api/v1'
// export const PUBLIC_PATH='/'

export const FACEBOOK_APP_ID=631437230238974
export const FACEBOOK_VERSION='v2.10'
export const FACEBOOK_SCOPE='email,public_profile'

export const GOOGLE_CLIENT_ID='774967315512.apps.googleusercontent.com'
export const GOOGLE_COOKIE_POLICY='single_host_origin'
export const GOOGLE_SCOPE='profile email'
